<template>
  <div class="projectList">
    <div v-show="loadingstatus">
      <Loader />
    </div>
    <div v-show="!loadingstatus">
      <!--Referece firebase via VUEX-->
      <projectCard v-for="project in projectInPublic" :key="project.id" :project="project" />
      <!--Referece firebase via conventional way (vue.js)-->
      <!--<projectCard v-for="project in projects" :key="project.id" :project="project" />-->
    </div>
    <div v-show="noproject">
      <h3>
        Let's add a new project!
      </h3>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/loading.vue';
import projectCard from '@/components/projectCard.vue';

// import projectDataCollection from '@/js/projectDataCollection.js';

export default {
  components: {
    projectCard,
    Loader,
  },
  data() {
    return {
      userid: this.$route.params.userId,
      projects: [],
    };
  },
  computed: {
    // ...mapState(['projectInfo', 'loadingStatus']),
    ...mapGetters(['projectInPublic', 'loadingstatus', 'noproject' ]),
  },
  created() {
    // 1) Load loading screen, 2) fetch datas, 3) hide loading and trigger boolean to show project list.
    this.fetchDatabaseForBrowsing();
    this.projectDetection();
  },
  methods: {
    ...mapActions(['projectDetection', 'fetchDatabaseForBrowsing']),
  },
};
</script>
